import { TableColumn } from '@siemens/component-lib';
import { TranslateService } from '@ngx-translate/core';
import { SnowflakeSearchResult } from '../../interfaces/workflows/SnowflakeSearchResult';

export class SnowflakeSearchTableOperations {
    public static getTableColumns(translateService: TranslateService): TableColumn<SnowflakeSearchResult>[] {
        return [
            {
                key: 'coreMlfb',
                title: translateService.instant('workflow.snowflake.table.columns.core-mlfb')
            },
            {
                key: 'gck',
                title: translateService.instant('workflow.snowflake.table.columns.gck')
            },
            {
                key: 'pck',
                title: translateService.instant('workflow.snowflake.table.columns.pck')
            },
            {
                key: 'priceGroup',
                title: translateService.instant('workflow.snowflake.table.columns.price-group')
            }
        ];
    }

    public static readonly tableConfig = {
        filterable: false,
        searchable: false,
        selectable: false,
        pagination: true,
        height: 'fit-content',
        severityCondition: () => false,
        backgroundColor: {
            light: '#F3F3F0',
            dark: '#08082E'
        }
    };
}
